export default __webpack_public_path__ + "static/media/hamburger-menu-white.b674fe48.svg";